import RedactText from "./optout-general-components/redacttext";
import ServiceCard from "./cards/servicecard";
import TailwindButton from "../general/tailwindButton";
import { serviceCards, landingpagetext } from "src/data/aiOptOut";
import Image from "next/image";
import Link from "next/link";

const Hero = () => {
  return (
    <>
      <div className="flex w-full items-end justify-center mt-24 h-24 sm:mt-28">
        <Link href="/ai-optout">
          <Image
            src={require("/public/images/aiOptOut/common/aiOptOut-logo.svg")}
            alt="Redact Logo"
            className=""
            width={200}
            height={123}
            priority
          />
        </Link>
      </div>
      <div className="flex w-full items-end justify-center mt-16">
        <div className="sm:w-[51%] w-[80%] text-center">
          <RedactText
            color="text-redactWhite font-bold"
            size="sm:text-[25px] text-3xl"
            text={`${landingpagetext.OptOutServices}`}
          />
        </div>
      </div>
      <div className="flex w-full items-end justify-center mt-6 ">
        <div className="sm:w-[51%] w-[80%] text-center">
          <RedactText
            color="text-gray-300"
            size="text-[16px]"
            text={`${landingpagetext.WelcomeText}`}
          />
        </div>
      </div>
      <div className="flex w-full items-end justify-center sm:-mt-10 mt-10 ">
        <div className="flex w-[350px] h-[730px] sm:w-[1210px] sm:h-[500px] items-end justify-center sm:mt-20 bg-gradient-to-r from-brand-blue to-brand-purple rounded-xl">
          <div className="flex flex-col sm:flex-row w-[346px] h-[726px] sm:w-[1206px] sm:h-[496px] sm:items-end bg-clip-border rounded-xl bg-brand-slate mb-[2px]">
            <div className="flex w-full items-end justify-center h-full rounded-xl">
              <div>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 mb-10">
                  {serviceCards
                    .sort((a, b) => a.order - b.order)
                    .map((card) => {
                      if (card.order > 12) {
                        return;
                      }
                      return (
                        <ServiceCard
                          key={card.order}
                          imagePath={card.imagePath.toString()}
                          isButton={true}
                          url={"/ai-optout-instructions/" + card.name.toString()}
                          logoWidth={card.width}
                          logoHeight={card.height}
                        />
                      );
                    })}
                </div>

                <div className="flex w-full items-end justify-center mb-10">
                  <TailwindButton
                    buttonBGColor="bg-brand-slate"
                    buttonBorderColor="border-brand-purple"
                    buttonHeight="h-[38px]"
                    buttonText="Explore 30+ services"
                    buttonTextTailwindStyle="font-bold text-[16px]"
                    buttonURL="/ai-optout-list"
                    buttonWidth="w-[200px]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full items-end justify-center mt-10">
        <div className="sm:w-[51%] w-[80%] text-center">
          <RedactText
            color="text-redactWhite font-bold"
            size="text-[21px]"
            text={`${landingpagetext.DataQuestion}`}
          />
        </div>
      </div>
    </>
  );
};

export default Hero;
